import {Component, Input, OnInit, QueryList, ViewChildren} from '@angular/core';
import {
  ContractAdvertisingCenterGroupComponent
} from '@shared/contract/contract-item/contract-general-informations/contract-advertising-center-group/contract-advertising-center-group.component';
import {Subject} from 'rxjs';

@Component({
standalone: false,
  selector: 'app-contract-advertising-center-informations',
  templateUrl: './contract-advertising-center-informations.component.html',
  styleUrls: ['./contract-advertising-center-informations.component.scss'],
})
export class ContractAdvertisingCenterInformationsComponent implements OnInit {
  @Input() contractOtherCentralAgencyList: any;

  @ViewChildren(ContractAdvertisingCenterGroupComponent)
  contractAdvertisingCenterGroupComponents!: QueryList<ContractAdvertisingCenterGroupComponent>;

  componentDestroyed$: Subject<void> = new Subject();

  constructor() {
  }

  ngOnInit(): void {
  }

  // --- Cancel ---

  public cancelFormsModification() {
    this.contractAdvertisingCenterGroupComponents.forEach(component => component.cancelFormsModification());
  }

  // --- Save ---

  public isFormValid(): boolean {
    return this.contractAdvertisingCenterGroupComponents.toArray().every(component => component.isFormValid());
  }

  public getFormsData() {
    return this.contractAdvertisingCenterGroupComponents.toArray().map(component => {
      const advertisingCenterFormValues = component.advertisingCenterFormGroup.value;

      if (
        advertisingCenterFormValues.otherCentralAgency === null &&
        advertisingCenterFormValues.customerServiceManager === null &&
        advertisingCenterFormValues.commercialAgent === null
      ) {
        return;
      }

      return {
        id: component.contractOtherCentralAgency?.id,
        contractId: component.contractOtherCentralAgency?.contractId,
        customerServiceManager: advertisingCenterFormValues.customerServiceManager || null,
        centralAgency: advertisingCenterFormValues.otherCentralAgency || null,
        commercialAgent: advertisingCenterFormValues.commercialAgent || null,
        isActive: component.contractOtherCentralAgency?.isActive,
        createdAt: component.contractOtherCentralAgency?.createdAt,
        updatedAt: new Date(),
      };
    });
  }

  public markAllAsTouched() {
    this.contractAdvertisingCenterGroupComponents.toArray().every(component => component.markAllAsTouched());
  }

  // --- On Destroy ---

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }
}
